import { fetchData } from '@umu/umu-fetch';
import API from '../../path';

export const getRichTextContent = async (params: { top_section_id: number }) => {
    return await fetchData(API.GET_RICH_TEXT_CONZTENZT, params).then(
        (res: any) => {
            return (res?.data?.content || '')
                .replace(/<script/g, '&lt;script')
                .replace(/<\/script>/g, '&lt;/script&gt;');
        },
        () => '',
    );
};

export const addRichTextContent = async (params: { content: string; ref_type: string; ref_id: number }) => {
    return await fetchData(API.ADD_RICH_TEXT_CONZTENZT, params);
};

export const updateRichTextContent = async (params: {
    content: string;
    ref_type: string;
    ref_id: number;
    top_section_id: number;
}) => {
    return await fetchData(API.UPDATE_RICH_TEXT_CONZTENZT, params);
};
